import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateCustomerTypes = function ({ match, history }) {
  const [formLayout] = useState('vertical')
  const defaultFormValues = { active: true }

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      name: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('description')))
    }),
    yupValidationUpdate: yup.object().shape({
      name: yup.string().max(60).typeError('must be string')
    }),
    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      if (!id) {
        const data = { ...values }
        storeCustomerTypes(data)
      } else {
        const payload = {
          data: {
            name: values.name,
            active: values.active
          },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateCustomerTypes(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER_TYPE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    if (id) {
      retrieveCustomerTypes(id)
    } else {
      setFormValues({})
    }

    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function storeCustomerTypes(data) {
    try {
      await request(api.storeCustomerTypes(data))
      notification.success({
        description: getMessage('successCreateCustomerTypes'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveCustomerTypes(id) {
    try {
      const response = await request(api.retrieveCustomerTypes(id))
      console.tron.log('response', response)
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateCustomerTypes(payload) {
    try {
      console.tron.log('updateCustomerTypes')
      const { id, data } = payload
      await request(api.updateCustomerTypes(id, data))
      notification.success({
        description: getMessage('successUpdateCustomerTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id ? getMessage('updateCustomerTypes') : getMessage('createCustomerTypes')
  }

  function renderHeader(submitForm) {
    const hasAccess = id ? validRule(RULES.CUSTOMER_TYPE) : validRule(RULES.CUSTOMER_TYPE)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          return (
            <Form className="login-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                    defaultValue={true}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="name"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    required
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default CreateCustomerTypes
